import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RouteDataService } from '@services/route-data/route-data.service';
import { DeletePricingDialogContentComponent } from './delete-pricing-dialog-content/delete-pricing-dialog-content.component';

@Component({
  selector: 'app-delete-pricing-dialog',
  template: ''
})
export class DeletePricingDialogComponent implements OnInit {

  constructor(
    public dialog: NgbModal,
    private activatedRoute: ActivatedRoute,
    private routeDataService: RouteDataService,
    private router: Router
  ) { }

  ngOnInit() {
    this.activatedRoute.paramMap.subscribe(params => {
      this.routeDataService.params = this.activatedRoute.snapshot.params;
      this.openDialog();
    });
  }

  openDialog(): void {
    var pricingId = this.activatedRoute.snapshot.params.key;

    const dialogRef = this.dialog.open(DeletePricingDialogContentComponent, { centered: true, backdrop: 'static', size: 'lg' });
    dialogRef.componentInstance.pricingId = pricingId;

    dialogRef.result.then((result) => {
      this.router.navigate(['../../'], { relativeTo: this.activatedRoute });
    }, (backdrop) => {
      this.router.navigate(['../../'], { relativeTo: this.activatedRoute });
    });
  }
}
